import { SET_PROTEINS } from '../actions/protein';

const initialState = {
  proteinsData: [],
};

const protein = (state = initialState, action) => {
  switch (action.type) {
    case SET_PROTEINS:
      return {
        ...state,
        proteinsData: action.payload,
      };

    default:
      return state;
  }
};

export default protein;